import { RoleType } from '@constants';
import { putApiGalaxyServer } from 'services';

export interface BulkUpdateTeamMembersAccessLevelPayload {
  team_id: number;
  team_membership_ids: number[];
  team_role: RoleType['roleId'];
}

export interface BulkUpdateTeamMembersAccessLevelSuccessResponse {
  team: { id: number };
}

export interface BulkUpdateTeamMembersAccessLevelErrorResponse {
  error: string;
  message: string;
  statusCode: number;
}

export const bulkUpdateTeamMembersAccessLevel = ({
  params: data,
  token,
  config = {},
}: BaseApiParams<BulkUpdateTeamMembersAccessLevelPayload>) =>
  putApiGalaxyServer(`/rails_api/team_memberships/bulk_update_permission`, data, config, token);
